import logo from '../../assets/palomma-logo-with-text.svg';

type Props = {
  width?: string;
  height?: string;
};

const PalommaLogoWithText = ({ width, height }: Props): JSX.Element => {
  return (
    <img
      src={logo}
      alt="Palomma Logo"
      style={{
        maxWidth: width || '100%',
        maxHeight: height || '100%',
        height: 'auto',
        width: 'auto',
      }}
    />
  );
};

export default PalommaLogoWithText;
